module.exports = __webpack_public_path__ + "img/share-dialog.f6dd8fd6.png";